import axios from 'axios'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import LocalForage from 'localforage'

import { fetchWithAuth } from '../../libs/fetchWithAuth';
import { getPayments } from './paymentActions'
import { getInvoices } from './invoiceActions'
import { getCustomers } from './customerActions'
import { getIntegrationsStates } from './integrationsActions'
import { updatePlan, updateRole } from './permsActions'
import { getRolePermissions } from './suraRolePermissionsActions';

// Local storage
import { persistor, store } from '../../app/store'
import { encryptCard } from '../../libs/utils'

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence, segmentTrackEvent, segmentIdentifyUser, segmentGroup } from '../../libs/utils'
import navigateTo from '../../app/navigateTo'

// Keycloak
import { shouldUseKeycloakLogout, getKeycloakLogoutUrl } from '../../components/auth/keycloakUtils';

import moment from "moment";

// Endpoints
import {
  USER_SETTINGS ,
  COUNTRY_REGION,
  CREATE_ACCOUNT,
  REQUEST_OTP,
  CONFIRM_OTP,
  LOGIN,
  OT_SIGNIN,
  PROFILE,
  TEAM,
  TEAM_STATS,
  TEAM_TOKEN,
  TEAMS,
  SUBSCRIPTION_ACTIVE,
  SUBSCRIPTION_ACTIVE_V2,
  SUBSCRIPTION_PAYMENT,
  SUBSCRIPTION_TRANSACTIONS,
  SUBSCRIPTION,
  SUBSCRIPTION_V2,
  CREATE_PAYMENT_METHOD,
  CREATE_NEW_TEAM,
  BUY_PACKAGES,
  VERIFY_ACCOUNT,
  REMOVE_PAYMENT_METHOD,
  USERS,
  INVITATIONS_USERS,
  VALIDATE_COUPON,
  ROLES_USERS,
  LOG_INSERT,
  KEYCLOAK_AUTH
} from '../../constants/endpoints';

// Endpoints
import {
  ENV

} from '../../constants/app';

// Actions
export const NEW_SETTINGS_PROFILE_DATA        = 'NEW_SETTINGS_PROFILE_DATA';
export const NEW_SETTINGS_PROFILE_DATA_MANUAL = 'NEW_SETTINGS_PROFILE_DATA_MANUAL';
export const NEW_SETTINGS_PAYMENT_DATA        = 'NEW_SETTINGS_PAYMENT_DATA';
export const NEW_SETTINGS_COLLECTION_DATA     = 'NEW_SETTINGS_COLLECTION_DATA';
export const NEW_SETTINGS_INTEGRATIONS_DATA   = 'NEW_SETTINGS_INTEGRATIONS_DATA';
export const SET_NEW_TOKEN                    = 'SET_NEW_TOKEN';
export const NEW_TEAM_DATA                    = 'NEW_TEAM_DATA';
export const CLEAR_TOKEN                      = 'CLEAR_TOKEN';
export const NEW_TEAM_SEGMENTATION            = 'NEW_TEAM_SEGMENTATION';
export const NEW_TEAM_STATS                   = 'NEW_TEAM_STATS';
export const NEW_TEAM_ADD                     = 'NEW_TEAM_ADD';
export const TEAMS_LIST                       = 'TEAMS_LIST';
export const VERIFY_ACCOUNT_ACTION = 'VERIFY_ACCOUNT_ACTION';
// Keycloak actions
export const NEW_KEYCLOAK_USER_DATA = 'NEW_KEYCLOAK_USER_DATA';


// Suscription
export const NEW_SUBSCRIPTION_DATA          = 'NEW_SUBSCRIPTION_DATA';
export const NEW_SUBSCRIPTION_PAYMENT       = 'NEW_SUBSCRIPTION_PAYMENT';
export const NEW_SUBSCRIPTION_TRANSACTIONS  = 'NEW_SUBSCRIPTION_TRANSACTIONS';
export const NEW_PAYMENT_METHOD             = 'NEW_PAYMENT_METHOD';
export const NEW_PACKAGE_DATA               = 'NEW_PACKAGE_DATA';
export const NEW_SUBSCRIPTION_COUPON        = 'NEW_SUBSCRIPTION_COUPON';
export const USERS_LIST                     = 'USERS_LIST';
export const USER_ROLES                     = 'USER_ROLES';


//::TODO:: purge unnecessary actions
export const CHANGE_USER_DATA               = 'CHANGE_USER_DATA';
export const LOG_OUT                        = 'LOG_OUT';
export const NEW_USER_DATA                  = 'NEW_USER_DATA';
export const OTP_TOKEN                      = 'OTP_TOKEN'
export const OTP_CONFITMATION               = 'OTP_CONFIRMATION'
export const REFRESH_TOKEN                  = 'REFRESH_TOKEN';
export const RESET_ACCOUNT                  = 'RESET_ACCOUNT';
export const SET_TOKEN                      = 'SET_TOKEN';
export const TOGGLE_KNOW_USER               = 'TOGGLE_KNOW_USER';
export const NEW_TEAM_EMAILS                = 'NEW_TEAM_EMAILS';

//MOBILE ALERTS
export const MOBILE_ALERT                   = 'MOBILE_ALERT'

// APP
export const TOGGLE_LOCALHOST               = 'TOGGLE_LOCALHOST';
export const SET_USER_SETTINGS              = 'SET_USER_SETTINGS';

// RETRIES
export const SET_RETRY_TO_EDIT              = 'SET_RETRY_TO_EDIT';
export const SET_NEW_RETRIES_TOKEN          = 'SET_NEW_RETRIES_TOKEN';

export function saveTeamSegmentation(industry, size) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_TEAM_SEGMENTATION,
    payload:{industry: industry, size: size}
  }));

} // END saveCompanySegmentation

/* ##############################
#### SUSCRIPTION ACTIONS
############################## */

export function getRolesList(page) {
  if(page === undefined) {
    return dispatch  => axios.get(ROLES_USERS)
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), USER_ROLES, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  } else {
    return dispatch  => axios.get(`${ROLES_USERS}?page=${page}`)
      .then(res => {
        thunkHandler(dispatch, get(res, 'data.data'), USER_ROLES, 'ERROR')
        return res;
      })
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }
}; //END getRolesList

export function getUserSettings() {
  return dispatch  => axios.get(USER_SETTINGS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data.application'), SET_USER_SETTINGS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

/**
 * setLogInsert - This function records the logs of the actions
 * @param {string} type action name
 * @param {object} body service request
 * @param {string} uuid current account id
 */
export function setLogInsert(type = '', body = {}, uuid = '') {
  const mainUrl = `${LOG_INSERT}`;

  const payload = {
    type,
    body
  }

  return dispatch => fetchWithAuth(mainUrl, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'user-uuid': `${uuid}`
      },
      body: JSON.stringify(payload)
    })
    .then( res => res )
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

}; //END setLogInsert

/**
 * getUsersList - Get users list
 * @param {number} page page number
 * @param {string} search search user string
 */
export function getUsersList(page = 1, search = '') {
  let url = '';
  if( search === '' ) {
    url = `${USERS}?page=${page}`;
  } else {
    url = `${USERS}?page=${page}${ search !== '' ? `&search=${search}` : '' }`;
  }
  return dispatch => axios.get(url)
    .then(res_users => axios.get(INVITATIONS_USERS)
      .then(res_invites => {
        const users = get(res_users, 'data.data', [])
        const invites = get(res_invites, 'data.data', [])

        // List of users sorted by name
        const sorted_users = [...users];
        sorted_users.sort((x, y) => x.name.localeCompare(y.name))

        thunkHandler(dispatch, [...sorted_users, ...invites], USERS_LIST, 'ERROR', [...sorted_users, ...invites])
      })
      .then( () => res_users )
    )
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

}; //END getUsersList

export function createNewTeam(uuid, body) {
  return dispatch => axios.post(parseUrl(CREATE_NEW_TEAM, { uuid }), body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_TEAM_ADD, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END createNewTeam

export function setNewToken(token) {
  return (dispatch) => dispatch({ type: SET_NEW_TOKEN, payload: token })

} // END setNewToken

export function setNewRetriesToken(token) {
  return (dispatch) => dispatch({ type: SET_NEW_RETRIES_TOKEN, payload: token })
}

export function setRetryToEdit (retry) {
  return (dispatch) => dispatch({ type: SET_RETRY_TO_EDIT, payload: retry })
}

export function getTeamToken(body) {
  return dispatch => axios.post(TEAM_TOKEN, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_USER_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))

} //END createNewTeam

export function getTeamsList() {
  return dispatch  => axios.get(TEAMS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data.teams'), TEAMS_LIST, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

}; // END getTeamsList

export function addPaymentMethod(card, key, rfc) {
  // POST /v1/team/payment_method
  return dispatch  => axios.post(CREATE_PAYMENT_METHOD, {...encryptCard(card, key, ENV), checkout_rfc: rfc })
    .then(res => new Consequence({ dispatch,
      payload    : { data: get(res, 'data.data') },
      eventTypes : { success: NEW_SUBSCRIPTION_PAYMENT, error: 'ERROR' }

    })); // END return

} // END addPaymentMethod

export function updatePaymentMethod(card, key) {
  // PUT /v1/team/payment_method
  return dispatch => axios.put(CREATE_PAYMENT_METHOD, encryptCard(card, key, ENV))
  .then(res => new Consequence({ dispatch,
    payload    : { data: get(res, 'data.data') },
    eventTypes : { success: NEW_SUBSCRIPTION_PAYMENT, error: 'ERROR' }

  })); // END return

} // END updatePaymentMethod

export function deletePaymentMethod() {
  return dispatch  => axios.delete(REMOVE_PAYMENT_METHOD)
    .then(() => {
      return new Consequence({ dispatch,
      payload    : { data: {} },
      eventTypes : { success: NEW_SUBSCRIPTION_PAYMENT, error: 'ERROR' }

    })}); // END return


} // END updatePaymentMethod

export function createSuscription(id, code, options, account) {
  if (!options) options = {};
  const { isFree } = options;
  let payload = { "plan_code": id };
  if(!isEmpty(code)) payload.discount_code = code

  if(isFree) {
    return dispatch => axios.put(SUBSCRIPTION_V2, payload)
      .then(() => axios.get(SUBSCRIPTION_ACTIVE))
      .then(response => {
        const newSubscription = get(response, 'data.data[0]');
        const payload = {
          company: {
            id : get(account, "team.uuid"),
            name : get(account, "team.name"),
            plan_name : get(newSubscription, "description"),
            plan_is_trial : get(newSubscription, "is_trial"),
            plan_start_at : moment.unix(get(newSubscription, "start_date")).format("DD-MM-YYYY, HH:mm"),
            plan_expire_at : moment.unix(get(newSubscription, "end_date")).format("DD-MM-YYYY, HH:mm"),
          }
        }
        segmentIdentifyUser({
          user: account,
          updateInformation: true,
          payload
        })
        return new Consequence({ dispatch,
          payload: { data: newSubscription },
          eventTypes: { success: NEW_SUBSCRIPTION_DATA, error: 'ERROR' }
        })
      })

  } else {
    return dispatch => axios.put(SUBSCRIPTION_V2, payload)
      .then(() => axios.get(SUBSCRIPTION_ACTIVE))
      .then(response => {
        const newSubscription = get(response, 'data.data[0]');
        const payload = {
          company: {
            id : get(account, "team.uuid"),
            name : get(account, "team.name"),
            plan_name : get(newSubscription, "description"),
            plan_is_trial : get(newSubscription, "is_trial"),
            plan_start_at : moment.unix(get(newSubscription, "start_date")).format("DD-MM-YYYY, HH:mm"),
            plan_expire_at : moment.unix(get(newSubscription, "end_date")).format("DD-MM-YYYY, HH:mm")
          }
        }
        segmentIdentifyUser({
          user: account,
          updateInformation: true,
          payload
        })
        return new Consequence({ dispatch,
          payload: { data: newSubscription },
          eventTypes: { success: NEW_SUBSCRIPTION_DATA, error: 'ERROR' }
        })
      })
  } // END if

} // END createSuscription

export function validateCoupon(params) {
  return dispatch => axios.get(parseUrl(VALIDATE_COUPON, {}, params))
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SUBSCRIPTION_COUPON, 'ERROR'))

} //END validateCoupon

export function clearCoupon() {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_SUBSCRIPTION_COUPON,
    payload: {}
  }))

} // END clearCoupon

export function buyPackage(packageCode) {
  /* ### El body para comprar folios y downloads:
  POST /v1/team/package/{ folios || downloads }
  { "code": { codes_folios || codes_downloads } */
  if(!packageCode) packageCode = '';
  if(packageCode.indexOf('Plan') >= 0) packageCode = packageCode.replace('Plan', '');
  const typeOfPackage = packageCode.indexOf('Folios') !== -1 ? 'folios' : 'downloads';
  const payload = { code: packageCode };
  const url = parseUrl(BUY_PACKAGES, { name: typeOfPackage });

  return dispatch  => axios.post(url, payload)
    .then(() => thunkHandler(dispatch, {}, NEW_SUBSCRIPTION_DATA, 'ERROR'))
    .catch((error) => {
      const status = get(error, 'response.status');
      const code = get(error, 'response.data.code');

      console.warn("xxx buyPackage", { packageCode, code, error });
      // if(status < 499 && status > 399) {
      //   console.warn("xxx buyPackage navigateTo", `/app/checkout?item=${packageCode}`);
      //   navigateTo({ to: `/app/checkout?item=${packageCode}` });
      // } // END if

      if(status < 499 && status > 399) navigateTo({ to: `/app/checkout?item=${packageCode}` });
      return Promise.reject(error);

    })
    // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END buyPackage

export function updateSubscription(plan_code) {
  return dispatch  => axios.put(SUBSCRIPTION_V2, {plan_code})
    .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SUBSCRIPTION_DATA, 'ERROR'))
    .catch((error) => {
      const status = get(error, 'response.status');

      if(status < 499 && status > 399) navigateTo({ to: `/app/checkout?item=${plan_code}` });
      return Promise.reject(error);

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateSubscription

export function deleteSubscription() {
  const cancelSubscription = {
    "enabled": false
  };
  return dispatch  => axios.delete(SUBSCRIPTION, cancelSubscription)
    .then(() => thunkHandler(dispatch, {}, NEW_SUBSCRIPTION_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSubscriptionDetails

export function getSubscriptionDetails() {
  return dispatch  => axios.get(SUBSCRIPTION_ACTIVE)
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_SUBSCRIPTION_DATA, error: 'ERROR' }
    }))
    .then((res) => {
      const plan = get(res, '[0].product.plan_code', 1);
      dispatch(updatePlan(plan || 1));
      return Promise.resolve(res);

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSubscriptionDetails

export function getSubscriptionPayment() {
  return dispatch  => axios.get(SUBSCRIPTION_PAYMENT)
    .then(res => {
      if(res.data.data){
        return thunkHandler(dispatch, get(res, 'data.data'), NEW_SUBSCRIPTION_PAYMENT, 'ERROR')
      } else {
        return thunkHandler(dispatch, {}, NEW_SUBSCRIPTION_PAYMENT, 'ERROR')
      }

    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSubscriptionPayment

export function getSubscriptionTransactions() {
  return dispatch  => axios.get(SUBSCRIPTION_TRANSACTIONS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_SUBSCRIPTION_TRANSACTIONS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSubscriptionTransactions


/* ##############################
#### USER SETTINGS ACTIONS
############################## */
export function getTeamSettings() {
  return dispatch  => axios.get(TEAM)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_TEAM_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getTeamSettings

export function updateMailRouting(body) {
  const { email_cc_collection, email_collection } = body;
  return dispatch => axios.put(TEAM, { email_cc_collection, email_collection })
    .then(res =>  thunkHandler(dispatch, get(res, 'data.data', body), NEW_TEAM_EMAILS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateMailRouting


export function getAccountProfile() {
  function parseProfileData(data){
    data.country = get(data, 'address.district.country_code');
    data.district = get(data, 'address.district.name');
    return data;

  } // END parseProfileData

  return dispatch  => axios.get(PROFILE)
    .then(res => thunkHandler(dispatch, parseProfileData(get(res, 'data.data')), NEW_SETTINGS_PROFILE_DATA, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getAccountProfile

export function updateAccountProfile(body, multipart, blockUpdate = false) {
  const options = {};
  if (multipart) Object.assign(options, { headers: { 'content-type': 'multipart/form-data' } });

  return dispatch  => axios.put(PROFILE, body, options)
    .then(() => {
      if (!blockUpdate) return thunkHandler(dispatch, body, NEW_SETTINGS_PROFILE_DATA, 'ERROR')
    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateAccountProfile

export function manualUpdateAccountProfile(body) {
  const payload = {};
  payload.address = {
    line_1   : body.line_1,
    line_2   : body.line_2,
    line_3   : body.line_3,
    city     : body.city,
    district : { name: body.district, country_code: body.country },
    zip_code : body.zip_code
  }
  payload.country = body.country;
  payload.district = body.district;
  payload.tax_profile = body.tax_profile;
  payload.legal_name = body.legal_name

  return {
    type: NEW_SETTINGS_PROFILE_DATA_MANUAL,
    payload : payload
  }

} // END manualUpdateAccountProfile

export function getCountryRegion(region) {
  function parseDistrictData(data){
    if (Array.isArray(data)) return data.map(el => ({ value: el.name, label: el.name }))
    else return null;

  } // END parseDistrictData

  return dispatch  => axios.get(parseUrl(COUNTRY_REGION, { region }))
    .then(res => thunkHandler(dispatch, parseDistrictData(get(res, 'data.data')), null, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getCountryRegion


/* ##############################
#### SESSION ACTIONS
############################## */
export function refreshToken() {
  let payload;

  return {
    type: REFRESH_TOKEN,
    payload
  };

} // END refreshToken


export function setToken() {
  let payload;

  return {
    type: SET_TOKEN,
    payload
  };

} // END setToken


/* ##############################
#### APP ACTIONS
############################## */
export function toggleLocalhost() {
  return dispatch => Promise.resolve(dispatch({ type: TOGGLE_LOCALHOST }))
    .then(() => dispatch(logOut()));

} // END toggleLocalhost


export function newUserData() {
  let payload;
  return {
    type: NEW_USER_DATA,
    payload
  };

} // END newUserData


export function clearToken(params) {
  const redirect = get(params, 'redirect');
  return (dispatch) => Promise.resolve(dispatch({ type: CLEAR_TOKEN, payload: null }))
    .then(() => (!!redirect && typeof redirect === 'string') ? navigateTo({ to: redirect }) : null);

} // END clearToken


export function purgeAccountData() {
  return (dispatch) => dispatch({ type: RESET_ACCOUNT, payload: null });

} // END purgeAccountData


export function logOut() {
  return dispatch => {
    const useKeycloakLogout = shouldUseKeycloakLogout();

    let logoutUrl = null;
    if (useKeycloakLogout) {
      logoutUrl = getKeycloakLogoutUrl();
    }

    localStorage.clear();
    sessionStorage.clear();

    dispatch({ type: LOG_OUT, payload: null });

    // Limpiar persistor si existe
    try {
      persistor.purge(store, {
        key: 'primary',
        storage: LocalForage,
        whitelist: ['invoices', 'account', 'form']
      });
      LocalForage.dropInstance();
      LocalForage.clear();
    } catch (error) {
      console.warn('Data purge failed', error);
    }

    if (useKeycloakLogout && logoutUrl) {
      window.location.replace(logoutUrl);
    }

    return Promise.resolve();
  };
}

export function logIn(form, knowUser) {
  form.time_zone = new Date().getTimezoneOffset();
  return dispatch => axios.post(LOGIN, form)
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_USER_DATA, error: 'ERROR' }
    }))
    .then(response => {
      const
        have_teams = get(response, 'account.have_teams'),
        teams      = get(response, 'account.teams');

      sessionStorage.setItem('session', true)

      if(!have_teams) {

        dispatch(updateRole(get(response, 'account.rol_id')))

        const company = get(response, 'account.team.uuid');

        axios.get(SUBSCRIPTION_ACTIVE_V2)
          .then(res => {
            const user = {
              ...get(response, "account"),
              subscription: get(res, "data.data[0]", {})
            }

            dispatch({ type: NEW_SUBSCRIPTION_DATA, payload: get(res, "data.data") })
            segmentIdentifyUser({
              user,
              updateInformation: true
            });

            segmentTrackEvent('Signin', company)
          })
          .then(() => {
            Promise.all([
              dispatch(getIntegrationsStates()),
              dispatch(getAccountProfile())
            ])
          })
          .then(() => knowUser ? dispatch({ type: TOGGLE_KNOW_USER }) : null)

      } else {
        axios.get(SUBSCRIPTION_ACTIVE_V2)
          .then(res => {
            const user = {
              ...get(response, "account"),
              subscription: get(res, "data.data[0]", {})
            }
            
            segmentIdentifyUser({
              user,
              updateInformation: true
            });
          })
        dispatch({ type: SET_NEW_TOKEN, payload: get(response, 'principal_token') })
        return teams

      }

    })

} // END logIn

export function logInFromSuperadmin(payload) {
  const company = get(payload, 'account.team.uuid');

  segmentTrackEvent('Imp-Signin', company);

  return dispatch => Promise.resolve(dispatch({
    payload,
    type: NEW_USER_DATA,
  }));

} // END logIn

export function createAccount(form) {
  return dispatch => axios.post(CREATE_ACCOUNT, form)
    .then(res => {
      const statusCode = get(res, 'status');
      if(statusCode) {
        const
        company             = get(res, 'data.data.team.uuid'),
        rol_id              = get(res, 'data.data.rol_id'),
        account_reference   = get(res, 'data.data.account_reference'),
        user = {
          ...get(res, "data.data"), 
          team: {
            ...get(res, "data.data.team"),
            profile: {
              phone: get(form, "phone")
            }
          },
          subscription: {...get(res, "data.data.team.subscription")},
          campaign: {...get(form, "attrs")}
        }

        let role = rol_id === 1 ? 'admin' : 'member';

        if (!account_reference) role = 'owner'

        if (role === "owner") {
          segmentIdentifyUser({
            user,
            updateInformation: true,
            isSignup: true
          })
        }

        segmentGroup(user);
        segmentTrackEvent('Signup', company);

      } // END if

      // 409 conflict > Dup email, ::TODO:: consider chnage to 204 plus Aplication code
      return thunkHandler(dispatch, get(res, 'data.data'), NEW_USER_DATA, 'ERROR');

    })
    // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END createAccount

export function requestOTP(payload) {
  return dispatch => axios.post(REQUEST_OTP, payload)
  .then(res => thunkHandler(dispatch, get(res, 'data'), OTP_TOKEN, 'ERROR'))
  .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
}

export function confirmOtp(payload) {
  return dispatch => axios.post(CONFIRM_OTP, payload)
  .then(res => thunkHandler(dispatch, get(res, 'data'), OTP_CONFITMATION, 'ERROR'))
  .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'))
}

export function verifyAccount(payload){
  return dispatch =>
    axios
      .post(VERIFY_ACCOUNT, payload)
      .then(() => dispatch({ type: VERIFY_ACCOUNT_ACTION }));
} // END verifyAccount



export function getTeamStats() {
  return dispatch  => axios.get(TEAM_STATS)
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_TEAM_STATS, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

}// END getTeamStats



export function otLogIn(token, signup) {
  const body = { token, time_zone: new Date().getTimezoneOffset() };
  console.log("XXX otLogIn", body);

  // return dispatch => axios.post("https://api.porcobrar.com/v1/ot_signin", body)
  return dispatch => axios.post(OT_SIGNIN, body)
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_USER_DATA, error: 'ERROR' }

    }))
    .then(response => {
      const
      rol_id            = get(response, 'account.rol_id'),
      account_reference = get(response, 'account.account_reference');

      let role = rol_id === 1 ? 'admin' : 'member';

      if (!account_reference) role = 'owner'

      return Promise.resolve({
        name        : get(response, 'account.name'),
        email       : get(response, 'account.email'),
        language    : 'ES',
        company     : get(response, 'account.team.uuid'),
        accountUuid : get(response, 'account.uuid'),
        phone       : get(response, 'account.team.profile.phone'),
        role

      }); // END return

    })
    .then(userData => {
      return axios.get(SUBSCRIPTION_ACTIVE)
        .then(response => {
          Object.assign(userData, {
            plan       : get(response, 'data.data[0].description'),
            expiration : get(response, 'data.data[0].end_date')

          });

          return Promise.resolve(userData);

        }); // END SUBSCRIPTION_ACTIVE

    })
    .then(userData => {
      const { accountUuid } = userData;

      segmentIdentifyUser({
        user: userData,
        updateInformation: true,
        isSignup: !!signup
      });
      delete userData.accountUuid;

      console.log("XXX segmentTrackEvent signup:", {  signup, accountUuid});

      // Segment tracking
      if (signup) segmentTrackEvent('Signup', userData.company)
      else          segmentTrackEvent('Signin', userData.company);

      return Promise.resolve();

    })
    .then(() => Promise.all([
      // Content
      dispatch(getInvoices({ activeTab: 1 })),
      dispatch(getPayments({ activeTab: 1 })),
      dispatch(getCustomers({ activeTab: 1 })),
      dispatch(getIntegrationsStates()),
      // Account
      dispatch(getAccountProfile())

    ])); // END return

} // END otLogIn

export function alertMobileNotification(accepted) {
  return {
    type: MOBILE_ALERT,
    payload: accepted
  }
}

// Keycloak
export function authenticateWithKeycloakToken() {
  return dispatch => {
    return axios
      .get(KEYCLOAK_AUTH)
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: parseKeycloakUserData(res) },
            eventTypes: { success: NEW_KEYCLOAK_USER_DATA, error: 'ERROR' }
          })
      )
      .then(response => {
        const have_teams = get(response, 'account.have_teams'),
          teams = get(response, 'account.teams');

        sessionStorage.setItem('session', true);

        if (!have_teams) {
          const roleId = get(response, 'account.rol_id');
          dispatch(updateRole(roleId));
          dispatch(getRolePermissions(roleId));

          const company = get(response, 'account.team.uuid');

          return axios
            .get(SUBSCRIPTION_ACTIVE_V2)
            .then(res => {
              const user = {
                ...get(response, 'account'),
                subscription: get(res, 'data.data[0]', {})
              };

              dispatch({ type: NEW_SUBSCRIPTION_DATA, payload: get(res, 'data.data') });
              segmentIdentifyUser({ user, updateInformation: true });
              segmentTrackEvent('Keycloak SSO Signin', company);
            })
            .then(() => {
              Promise.all([dispatch(getIntegrationsStates()), dispatch(getAccountProfile())]);
              // Return response with rol_id for routing decisions
              return response;
            });
        } else {
          return axios.get(SUBSCRIPTION_ACTIVE_V2).then(res => {
            const user = {
              ...get(response, 'account'),
              subscription: get(res, 'data.data[0]', {})
            };

            dispatch({ type: NEW_SUBSCRIPTION_DATA, payload: get(res, 'data.data') });
            segmentIdentifyUser({ user, updateInformation: true });

            return teams;
          }).then(() => {
            // Return response with rol_id for routing decisions
            return response;
          });
        }
      })
      .catch(error => {
        throw error;
      });
  };
}

// Función para parsear datos de Keycloak
function parseKeycloakUserData(response) {
  const data = get(response, 'data.data', {});
  const teams = Array.isArray(get(data, 'teams')) ? get(data, 'teams') : [];
  const have_teams =
    typeof get(data, 'have_teams') === 'boolean' ? get(data, 'have_teams') : teams.length > 1;
  const team = get(data, 'team') || (teams.length === 1 ? teams[0] : undefined);

  return {
    account: {
      ...(data || {}),
      teams,
      have_teams,
      ...(team ? { team } : {})
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/accountActions.js